export default "__VITE_ASSET__1f70bf38__"